import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=106e6461&scoped=true"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"
import style0 from "./Scene.vue?vue&type=style&index=0&id=106e6461&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e6461",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106e6461')) {
      api.createRecord('106e6461', component.options)
    } else {
      api.reload('106e6461', component.options)
    }
    module.hot.accept("./Scene.vue?vue&type=template&id=106e6461&scoped=true", function () {
      api.rerender('106e6461', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-research/components/Scene.vue"
export default component.exports